<template>
  <v-card outlined elevation="0" style="border: none">
    <v-card-title>
      <h3>Loco operating in {{ poiCountry.country }} </h3>
    </v-card-title>
    <v-card-text class="pt-3">
      <v-row class="px-2 mb-2">
        <v-col>
          <div>
            <span class="mtitle"
              >{{ $t("message.pageKm.loco", { value: "default" }) }}:</span
            >
            <span class="value">{{ poiCountry.group }}</span>
          </div>
          <v-divider class="mb-4"></v-divider>
          <div>
            <span class="mtitle"
              >{{ $t("message.geofencing.entry", { value: "default" }) }} :</span
            >
            <span class="value">{{ formatdate(poiCountry.start) }}</span>
          </div>

          <div v-if="poiCountry.ended">
            <span class="mtitle"
              >{{ $t("message.geofencing.exit", { value: "default" }) }} :</span
            >
            <span class="value">{{ formatdate(poiCountry.end) }}</span>
          </div>

          <div class="mt-5">
            <span v-if="poiCountry.country == 'Germany'" class="value">{{ $t("message.geofencing.dbenergy", { value: "default" }) }}</span>
          </div>
        </v-col>
      </v-row>

    </v-card-text>
  </v-card>
</template>

<script>
import { formatMagicDate, formatTimelinePoiToolTipTime } from "@/shared/DateHelper";
export default {
  props: ["poiCountry"],

  methods: {
    formatdate(date) {
      return formatMagicDate(date)+ " " + formatTimelinePoiToolTipTime(date, this.$i18n.locale);
    },
  },

};
</script>

<style scoped>
.dp {
  color: #00475a;
  font-weight: bolder;
}

.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  color: #fff;
  font-size: 16px;
}

.mtitle {
  color: #00475a;
  margin-bottom: 5px;
  margin-top: 20px;
  font-size: 16px;
  font-weight: bolder;
}

.value {
  font-size: 16px;
}
</style>
